import { useRentalManagerUserPropertyFeedFloorPlanWebApiHandler_delete } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { usePropertyEditMutation } from './usePropertyEditMutation';
import { FEED_OVERRIDES_TAG } from '../constants/FeedOverrideConstants';

/**
 * Deletes a supplemented (ZRM) feed floor plan by removing its zramModel feed override. Feed-provided floor plans
 * can't be deleted this way. The caller shows its own status message, so the mutation skips the default toast.
 */
export const useDeleteFeedFloorPlan = (listingAlias: string) => {
  const { mutateAsync, isPending } = usePropertyEditMutation({
    mutationHook: useRentalManagerUserPropertyFeedFloorPlanWebApiHandler_delete,
    skipToast: true,
    meta: {
      invalidates: [FEED_OVERRIDES_TAG, 'mf-costsAndFees'],
      context: { api: 'RentalManagerUserPropertyFeedFloorPlanWebApiHandler_delete', details: { listingAlias } },
    },
  });

  const deleteFeedFloorPlan = (feedModelId: string) => mutateAsync({ postData: { listingAlias, feedModelId } });

  return { deleteFeedFloorPlan, isPending };
};
